<template>
  <!-- start navigator -->
  <div class="container ps-lg-5 pe-lg-5 mt-1">
    <div class="row">
      <div
        class="
          col-12
          d-none d-lg-flex
          justify-content-between
          align-items-center
        "
      >
        <nav style="--bs-breadcrumb-divider: '>'" aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link
                class="text-decoration-none router-link"
                to="/AgenteService"
                >หน้าแรก</router-link
              >
            </li>
            <li class="breadcrumb-item router-link active">
              ขอโอนตัวแทนใต้สังกัด (หน่วยดำเนินการ)
            </li>
          </ol>
        </nav>
      </div>
    </div>
  </div>
  <!-- end navigator -->
  <div class="container-lg">
    <div class="row">
      <!-- Left Menu -->
      <div class="col-left-menu">
        <div class="left-menu">
          <ul class="d-none d-lg-block">
            <Menu />
          </ul>
        </div>
      </div>
      <!-- Left Menu -->
      <!-- Mobile -->
      <div
        class="
          col-left-menu
          d-flex d-lg-none
          border-bottom
          align-items-center
          border-bottom
          w-100
          pl-3
          pr-3
        "
        style="background-color: #f2f2f2"
      >
        <div class="icon-back">
          <router-link to="/AgenteService">
            <img src="@/assets/images/arrow-blue.svg" class="w-100" />
          </router-link>
        </div>
        <div
          class="title ps-md-3 ps-lg-3 d-block d-lg-none text-center w-100"
          style="font-family: DB Heavent; color: #0057a8"
        >
          ขอโอนตัวแทนใต้สังกัด (หน่วยดำเนินการ)
        </div>
      </div>
      <!-- Mobile -->
      <div class="col col-content">
        <div class="d-none d-lg-flex align-items-center border-bottom">
          <div class="icon-back">
            <router-link to="/AgenteService">
              <img src="@/assets/images/arrow-blue.svg" class="w-100" />
            </router-link>
          </div>
          <div
            class="
              title
              blue-1
              fw-normal
              ps-md-3
              pe-lg-3
              font-family
              d-none d-md-block d-lg-block
            "
          >
            ขอโอนตัวแทนใต้สังกัด (หน่วยดำเนินการ)
          </div>
        </div>
        <div class="pb-2 pb-lg-2">
          <div class="mt-2 mt-lg-2">
            <ul class="list-group">
              <li class="list-group-item list-group-item-action blue-1">
                <div
                  class="
                    col-12
                    d-flex
                    flex-row flex-wrap
                    justify-content-between
                  "
                >
                  <div class="text-start gary-3 fw-normal font-family fs-5">
                    ระบุตัวแทนใต้สังกัดที่ต้องการโอน<span class="required"
                      >*</span
                    >
                  </div>
                  <div class="text-end">
                    <input
                      type="checkbox"
                      class="form-check-input"
                      @click="CheckAll()"
                      v-model="isCheckAll"
                    /><label class="fw-normal font-family fs-5 ps-1"
                      >เลือกทั้งหมด</label
                    >
                  </div>
                </div>
              </li>
              <li
                class="list-group-item list-group-item-action blue-1"
                v-for="(lang, index) in langsdata"
                :key="index"
              >
                <div class="col-12 row">
                  <div class="w-auto">
                    <input
                      type="checkbox"
                      class="form-check-input"
                      :key="lang.index"
                      :value="lang.AGENTCODE"
                      v-model="languages"
                      @change="UpdateCheckall(lang.index)"
                    />
                  </div>
                  <div class="w-auto pd-0">
                    <label class="fw-normal font-family fs-5 ps-1">
                      รหัส {{ lang.AGENTCODE }} {{ lang.PRENAME }} {{ lang.NAME }} {{ lang.SURNAME }}
                    </label>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="pb-3 pb-lg-3 mt-2 mt-lg-1">
          <div class="gray-3 fs-5 d-lg-inline-block mt-lg-2 font-family">
            เปลี่ยนเป็น :
          </div>
          <div class="gray-3 fs-5 font-family">
            สังกัดใหม่<span class="required">*</span>
          </div>
          <div class="ps-2 row font-family">
            <div class="col-11" style="padding-right: initial">
              <input
                v-model="this.AgentCode"
                type="text"
                class="field field__input a-field__input fs-6"
                style="border-bottom: 1px solid #d0d0d0; font-family: monospace;"
                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                maxlength="8"
                @change="format(this.AgentCode)"
              />
            </div>
            <div class="col-1" style="padding-left: inherit">
              <font-awesome-icon
                style="
                  color: #0057a8;
                  width: 24px;
                  height: 24px;
                  margin-top: 25px;
                  cursor: pointer;
                "
                :icon="IconSearch"
                @click="Search(this.AgentCode)"
              />
            </div>
            <div v-if="this.TransCode !== ''" >
              <label style="font-family: monospace;" class="blue-1 fs-6">{{  this.TransCode }}</label> <label class="font-family fs-4 fw-normal blue-1">{{ this.TransPrename }} {{ this.TransName }} {{ this.TransSurname }}</label>
            </div>
          </div>
        </div>
        <div class="col mt-2 mb-2 mb-lg-1">
          <button class="btn-CB border border-0 rounded w-100 font-family" @click="EnterNext()">
            <label class="btn-next">ดำเนินการต่อ</label>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div v-if="this.Loading">
    <LoadingBs5></LoadingBs5>
  </div>
</template>

<script>
import Menu from "@/components/agenteservice/Menu.vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";

import LoadingBs5 from "@/components/frontend/LoadingBs5";
import http from "@/services/AuthService";
import Swal from 'sweetalert2/src/sweetalert2.js'

export default {
  name: "TransferAgentView",
  components: {
    Menu,
    FontAwesomeIcon,
    LoadingBs5,
  },
  data() {
    return {
      IconSearch: faMagnifyingGlass,
      isCheckAll: false,
      languages: [],
      langsdata: [],
      AgentCode: '',
      TransCode: '',
      TransPrename: '',
      TransName: '',
      TransSurname: '',
      Loading: true,
      CheckSearch: false
    };
  },
  mounted() {
    if(this.$store.state.AgentCode == '') {
      this.$router.push('/');
    }

    // let AuthorizeToken = this.$cookies.get("AuthorizeToken");
    let AuthorizeToken = localStorage.getItem("AuthorizeToken");
    http.get("AgencyERequest/GetName?",{ headers: { Authorization: `Bearer ${AuthorizeToken}` } }).then((response) => { 
      if(response.status == 200) {
        this.$store.state.UserName = response.data.NAME + " " + response.data.SURNAME;

        let params = { AGENTCODE: response.data.AGENTCODE };
        http.get("AgencyERequest/Permission?", { headers: { Authorization: `Bearer ${AuthorizeToken}` }, params }).then(() => { 
          
        }).catch(() => { 
          Swal.fire({
            icon: 'error',
            html: '<label class="fs-4 fw-normal font-family">สำหรับผู้บริหารหน่วยดำเนินการเท่านั้น</label>',
          }).then(() => { 
            this.$router.push("/AgenteService");
          });
        });
      }
      else {
        localStorage.removeItem("Token");
        localStorage.removeItem("AuthorizeToken");
        window.open(process.env.VUE_APP_URL_ADFS + "AgencyERequestConvertor", '_self');
      }
    }).catch((error) => { 
      Swal.fire({
        icon: 'error',
        html: '<label class="fs-4 fw-normal font-family">'+ error.response.data.ErrorMessage +'</label>',
      }).then(() => { 
        localStorage.removeItem("Token");
        localStorage.removeItem("AuthorizeToken");
        window.open(process.env.VUE_APP_URL_ADFS + "AgencyERequestConvertor/Logout", '_self');
      });
    });

    http.get("AgencyERequest/GetUnderManagerOffice?",{ headers: { Authorization: `Bearer ${AuthorizeToken}` } }).then((res) => { 
      if(res.status == 200) {
        res.data.forEach(item => {
          this.langsdata.push({
            AGENTCODE: item.AGENTCODE,
            PRENAME: item.PRENAME,
            NAME: item.NAME,
            SURNAME: item.SURNAME
          });
        });

        this.Loading = false;
      }
    }).catch(() => { 
      this.Loading = false; 
      Swal.fire({
        icon: 'error',
        html: '<label class="fs-4 fw-normal font-family">สำหรับผู้บริหารหน่วยดำเนินการเท่านั้น</label>',
      });
    });
  },
  watch:{
    AgentCode() {
      this.TransCode = '';
      this.TransPrename = '';
      this.TransName = '';
      this.TransSurname = '';
      this.CheckSearch = false;
    },
  },
  methods: {
    CheckAll() {
      this.isCheckAll = !this.isCheckAll;
      this.languages = [];
      if (this.isCheckAll) {
        // Check all
        for (var key in this.langsdata) {
          this.languages.push(this.langsdata[key].AGENTCODE);
        }
      }
    },
    UpdateCheckall(id) {
      if (this.languages.length == this.langsdata.length) {
        this.isCheckAll = true;
      } else {
        this.isCheckAll = false;
      }
    },
    Search(val) {
      // let AuthorizeToken = this.$cookies.get("AuthorizeToken");
      let AuthorizeToken = localStorage.getItem("AuthorizeToken");
      let params = {
        AgentCode: val,
        SUBJOB: this.$store.state.AGENT_TRAN.SUBJOB
      }; 
      this.Loading = true;
      http.get("AgencyERequest/GetDataAgentCenter?", { headers: { Authorization: `Bearer ${AuthorizeToken}` }, params }).then((res) => { 
        if(res.status == 200) {
          this.Loading = false;

          if(res.data.PRENAME == null && res.data.NAME == null && res.data.SURNAME == null) { 
            Swal.fire({
            icon: 'error',
              html: '<label class="fs-4 fw-normal font-family">ไม่พบข้อมูลตัวแทน</label>',
            });
          }
          else {
            this.TransCode = res.data.AGENTCODE,
            this.TransPrename = res.data.PRENAME,
            this.TransName = res.data.NAME,
            this.TransSurname = res.data.SURNAME
            this.CheckSearch = true;
          }
        }
        else {

        }
      });
    },
    EnterNext() {
      if(this.languages.length <= 0) { 
        Swal.fire({
          icon: 'error',
          html: '<label class="fs-4 fw-normal font-family">กรุณาระบุตัวแทนใต้สังกัดที่ต้องการโอน</label>',
        });
      }
      else if (this.AgentCode === '' || this.CheckSearch == false) { 
        Swal.fire({
          icon: 'error',
          html: '<label class="fs-4 fw-normal font-family">กรุณาระบุรหัสตัวแทนสังกัดใหม่ หรือตรวจสอบความถูกต้องโดยกดแว่นขยาย</label>',
        });
      }
      else {
        // let AuthorizeToken = this.$cookies.get("AuthorizeToken");
        let AuthorizeToken = localStorage.getItem("AuthorizeToken");
        this.$store.state.AGENT_TRAN.AGENTCODE_TRAN = [];
        this.$store.state.PASS_TRANFER.DETAIL = [];
        
        this.languages.forEach(item => {
          this.langsdata.forEach(data => {
            if(item === data.AGENTCODE) { 
              let AGENT_NAME = data.AGENTCODE + " " + data.PRENAME + " " + data.NAME + " " + data.SURNAME;
              this.$store.state.PASS_TRANFER.DETAIL.push(AGENT_NAME);
            }
          });

          //SET INSERT DATABASE
          this.$store.state.AGENT_TRAN.AGENTCODE_TRAN.push(item);
        });

        let request = {
          AGENTCODE: this.$store.state.AGENT_TRAN.AGENTCODE_TRAN,
          SUBJOB: this.$store.state.AGENT_TRAN.SUBJOB,
        }

        http.post("AgencyERequest/CheckCreateJob?", request, { headers: { Authorization: `Bearer ${AuthorizeToken}` } }).then((response) => { 
          if(response.status == 200) {
            if(response.data !== '001' && response.data !== '002') { 
              this.$store.state.PASS_TRANFER.TransFullName = this.TransCode + " " + this.TransPrename + " " +this.TransName + " " +this.TransSurname;

              //SET INSERT DATABASE
              this.$store.state.AGENT_TRAN.AGENTCODE_NEW_UPLINE = this.TransCode;

              this.$router.push('/FinishTranferAgent');
            }
            else {
              Swal.fire({
                icon: 'error',
                html: '<label class="fs-4 fw-normal font-family">ไม่สามารถทำรายการนี้ได้ เนื่องจากมีการร้องของานไปแล้วก่อนหน้า</label>',
              });

              this.$router.push("/AgenteService");
            }
          }
        }).catch((error) => { 

        });
      }
    },
    format(val) { 
      this.AgentCode = String(val).padStart(8, '0');
      return this.AgentCode;
    },
  },
};
</script>

<style scoped>
.btn-CB {
  min-height: 50px;
  font-size: 26px;
  font-size: 1.625rem;
  background-color: #0057a8;
}
</style>